import { render } from "./AppSideMenu.vue?vue&type=template&id=941edcec&scoped=true"
import script from "./AppSideMenu.vue?vue&type=script&lang=js"
export * from "./AppSideMenu.vue?vue&type=script&lang=js"

import "./AppSideMenu.vue?vue&type=style&index=0&id=941edcec&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-941edcec"]])

export default __exports__